<script>
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import validations, { getLabelTitleErrorMessage } from './validations';
import { useVuelidate } from '@vuelidate/core';
import LabelSearchInput from './LabelSearchInput.vue';
import { labelTypeOptions } from './AddLabel.vue';

export default {
  components: {
    LabelSearchInput,
  },
  props: {
    selectedResponse: {
      type: Object,
      default: () => {},
    },
  },
  emits: ['close'],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      // title: '',
      description: '',
      labelName: {
        l1_label: '',
        l2_label: '',
        l3_label: '',
      },
      labelType: 'Pre-Sale',
      showOnSidebar: true,
      color: '',
      labelTypeOptions,
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: 'labels/getUIFlags',
    }),
    pageTitle() {
      return `${this.$t('LABEL_MGMT.EDIT.TITLE')} - ${
        this.selectedResponse.title
      }`;
    },
    labelTitleErrorMessage() {
      const errorMessage = getLabelTitleErrorMessage(this.v$);
      return this.$t(errorMessage);
    },
  },
  mounted() {
    this.setFormValues();
  },
  methods: {
    onClose() {
      this.$emit('close');
    },
    setFormValues() {
      // this.title = this.selectedResponse.title;
      this.labelName.l1_label = this.selectedResponse.l1_label;
      this.labelName.l2_label = this.selectedResponse.l2_label;
      this.labelName.l3_label = this.selectedResponse.l3_label;
      this.labelType = this.selectedResponse.label_type;
      this.description = this.selectedResponse.description;
      this.showOnSidebar = this.selectedResponse.show_on_sidebar;
      this.color = this.selectedResponse.color;
    },
    async editLabel() {
      // 先校验 LabelSearchInput 组件
      const labelSearchInputRef = this.$refs.labelSearchInput;
      if (labelSearchInputRef) {
        const isValid = await labelSearchInputRef.validate();
        if (!isValid) {
          return; // 校验失败，不继续执行
        }
      }
      // 格式化标签名称
      const formatLabel = (label) => {
        if (!label) return '';
        return label.trim()
          // .replace(/\s+/g, '_')
          // .toLowerCase();
      };

      this.$store
        .dispatch('labels/update', {
          id: this.selectedResponse.id,
          color: this.color,
          description: this.description,
          // title: this.title.toLowerCase(),
          l1_label: formatLabel(this.labelName.l1_label),
          l2_label: formatLabel(this.labelName.l2_label),
          l3_label: formatLabel(this.labelName.l3_label),
          label_type: this.labelType,
          show_on_sidebar: this.showOnSidebar,
        })
        .then(() => {
          useAlert(this.$t('LABEL_MGMT.EDIT.API.SUCCESS_MESSAGE'));
          setTimeout(() => this.onClose(), 10);
        })
        .catch((error) => {
          console.dir('error.message: ', error.message);
          const errorMessage = error.message || this.$t('LABEL_MGMT.EDIT.API.ERROR_MESSAGE');
          useAlert(errorMessage);
        });
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header :header-title="pageTitle" />
    <form class="flex flex-wrap mx-0" @submit.prevent="editLabel">
      <!-- <woot-input
        v-model="title"
        :class="{ error: v$.title.$error }"
        class="w-full label-name--input"
        :label="$t('LABEL_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('LABEL_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="labelTitleErrorMessage"
        @input="v$.title.$touch"
        @blur="v$.title.$touch"
      /> -->
      <LabelSearchInput 
        ref="labelSearchInput"
        v-model="labelName"
      />
      <label class="w-full">
        * {{ $t('LABEL_MGMT.FORM.LABEL_TYPE.LABEL') }}
        <select v-model="labelType">
          <option v-for="option in labelTypeOptions" :key="option.id" :value="option.id">
            {{ option.name }}
          </option>
        </select>
      </label>

      <woot-input
        v-model="description"
        :class="{ error: v$.description.$error }"
        class="w-full"
        :label="`* ${$t('LABEL_MGMT.FORM.DESCRIPTION.LABEL')}`"
        :placeholder="$t('LABEL_MGMT.FORM.DESCRIPTION.PLACEHOLDER')"
        @input="v$.description.$touch"
        @blur="v$.description.$touch"
      />

      <div class="w-full">
        <label>
          {{ $t('LABEL_MGMT.FORM.COLOR.LABEL') }}
          <woot-color-picker v-model="color" />
        </label>
      </div>
      <div class="flex items-center w-full gap-2">
        <input v-model="showOnSidebar" type="checkbox" :value="true" />
        <label for="conversation_creation">
          {{ $t('LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.LABEL') }}
        </label>
      </div>
      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <woot-button
          :is-disabled="uiFlags.isUpdating"
          :is-loading="uiFlags.isUpdating"
        >
          {{ $t('LABEL_MGMT.FORM.EDIT') }}
        </woot-button>
        <woot-button class="button clear" @click.prevent="onClose">
          {{ $t('LABEL_MGMT.FORM.CANCEL') }}
        </woot-button>
      </div>
    </form>
  </div>
</template>
